module.exports = __webpack_public_path__ + "static/img/IMG_20241027_131516.4dee2ac1.jpg";